export const PRIMARY_COLOR = '#a0d3a5';
export const ACCENT_COLOR = '#f6b3c1';
export const SECOND_COLOR = '#a2cff0';
export const SECOND_ACCENT_COLOR = '#d2b48c';